<template>
  <div>
    <h1>{{ welcomeMessage }}</h1>
    <button v-on:click="this.$router.push({ path: `/pricelist` })">{{ $t('pricelist.title') }}</button>
    <div v-if="pending">
      <svg-icon type="mdi" :path="iconLoading" class="rotate"></svg-icon> {{ $t('shops.loading') }}
    </div>
    <div v-else-if="parent">
      <button v-on:click="this.$router.push({ path: `/shops` })">{{ $t('shops.title') }}</button>
    </div>
    <BalanceReport :shopId=0 :shopName="this.shopName" />
  </div>
</template>

<script>
import { apiEndpoint, apiVersionParent } from '@/scripts'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiLoading, mdiMagnify } from '@mdi/js'
import BalanceReport from '@/components/BalanceReport.vue'
import axios from 'axios'

export default {
  data() {
    return {
      iconLoading: mdiLoading,
      iconSearch: mdiMagnify,
      pending: false,
      error: 0,
      parent: false,
      shopName: ""
    }
  },
  components: {
    SvgIcon,
    BalanceReport
  }, mounted() {
    document.title = this.$t('title') + ' - ' + this.$t('home.title');
    this.shopName = localStorage.getItem('username');
    this.$emit("getBalance");
    this.loadParentState();
  }, methods: {
    loadParentState() {
      this.pending = true;
      this.error = 0;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      };
      axios.get(apiEndpoint + apiVersionParent + "/ping", config)
        .then(res => {
          this.pending = false;
          this.parent = res.data.Result;
        })
        .catch(error => {
          this.pending = false;
          if (error) {
            this.error = 100;
          }
        });
    }
  }, computed: {
    welcomeMessage() {
      return this.$t("home.welcome").replace("###USER###", localStorage.getItem("username"));
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/master.scss';

.transactionlist {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    max-width: fit-content;
    margin: 0 auto;
    border: 1px solid black;
}

.transactionlist>div {
    text-align: left;
    padding: 10px 20px;
    border: 1px solid black;
}

.transactionlist>div.currency {
    text-align: right;
}
</style>